import React from 'react';
import { PumpStatusChangeTemplate } from 'themes/application/pumps/components';
import { observer } from 'mobx-react';
import { PumpStatusChangeViewStore } from 'application/pumps/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new PumpStatusChangeViewStore(rootStore, componentProps), 'editView')
@observer
class PumpStatusChange extends React.Component {
    render() {
        return <PumpStatusChangeTemplate {...this.props} />
    }
}

export default PumpStatusChange;